import { Navigate, Outlet, useLocation } from 'react-router-dom';
import authService from 'api/auth.service';

/**
 * GuestGuard: Prevents authenticated users from accessing guest-only routes
 * If user is already authenticated, redirects to dashboard
 */
const GuestGuard = () => {
  const isAuthenticated = authService.isAuthenticated();
  const location = useLocation();

  if (isAuthenticated) {
    // Redirect to intended destination or role-based dashboard
    let from = location.state?.from?.pathname;
    
    if (!from) {
      // Check user role and redirect accordingly
      const userJson = localStorage.getItem('user');
      if (userJson) {
        try {
          const user = JSON.parse(userJson);
          from = user.role === 'super_admin' ? '/admin/dashboard' : '/dashboard';
        } catch {
          from = '/dashboard';
        }
      } else {
        from = '/dashboard';
      }
    }
    
    return <Navigate to={from} replace />;
  }

  return <Outlet />;
};

export default GuestGuard;
